import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GeckoBtn, GeckoField } from 'ui';

import './index.scss';

class BotTabTableContainer extends Component {
  state = {
    searchValue: '',
  };

  static propTypes = {
    title: PropTypes.string,
    createText: PropTypes.string,
    noCreate: PropTypes.bool,
    onSearch: PropTypes.func,
    searchValue: PropTypes.string,
    children:  PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    headerChild: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  };

  static defaultProps = {
    noCreate: false,
    headerChild: null,
  };

  componentDidMount() {
    this.setState({ searchValue: this.props.searchValue || '' });
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchValue !== prevProps.searchValue) {
      this.setState({ searchValue: this.props.searchValue });
    }
  }

  handleSearchInput(_key, value) {
    this.setState({ searchValue: value });
  }

  renderSearchField() {
    const field = {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_SEARCH,
    };
    const onSubmit = (event) => {
      event.preventDefault();
      this.props.onSearch(event.target.querySelector('input').value);
    };
    return (
      <form onSubmit={onSubmit}>
        <GeckoField
          values={{ value: this.state.searchValue }}
          field={field}
          handler={this.handleSearchInput.bind(this)}
        />
      </form>
    );
  }

  render() {
    return (
      <div className="BotTabTableContainer card gecko-card clearfix">
        <div className="BotTabTableContainer-header-container gecko-card-header">
          <div className="BotTabTableContainer-title">
            <h2 className="header-title">{this.props.title}</h2>
          </div>
          <div className="BotTabTableContainer-filters">
            {this.props.onSearch ? this.renderSearchField() : null}
            {this.props.headerChild}
          </div>
        </div>
        <div className="BotTabTableContainer-table gecko-card-body">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default BotTabTableContainer;
